// extracted by mini-css-extract-plugin
export default {"label":"Label__label--MzX","readOnly":"Label__readOnly--SDG","hint":"Label__hint--337","fieldLabelAsterisk":"Label__fieldLabelAsterisk--3-n","tooltipIcon":"Label__tooltipIcon--2DB"};